<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Pay Elective Fees </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        item-value="ay_id"
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                        @change="getElectiveChoiceFeeDetails()"
                    />
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display" v-if="choice_list!=null">
                <v-col cols="12"><b>AY:</b> {{ ay_name }}</v-col>
                <v-col cols="12"><b>PRN:</b> {{ stud_data.registration_number }}</v-col>
                <v-col cols="12"><b>Full Name:</b> {{ stud_data.stud_fullname }}</v-col>
                <v-col cols="12"><b>Standard:</b> {{ stud_data.standard }}</v-col>
                <v-col cols="12"><b>Division:</b> {{ stud_data.division }}</v-col>
            </v-row>
            <v-row justify="center" dense class="no-display" v-if="receipts!=''">
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Receipts </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" md="12" sm="12" class="px-0">
                    <v-data-table
                        :items="receipts"
                        :headers="headers"
                        v-if="receipts!=''"
                        class="elevation-1 mytable"
                        dense
                        :search="search"
                    >
                        <template v-slot:[`item.print`]="{ item }">
                            <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        class="my-2"
                                        outlined
                                        rounded
                                        small
                                        color="warning"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="print(item.receipt_no, item.ay)"
                                    >
                                        <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn
                                    >
                                </template>
                                <span> Print Fee Receipt!!! </span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>

            <v-row justify="center" dense class="no-display" v-if="choice_list!=null">
                <v-toolbar class="toolbar no-display" flat dense>
                    <v-toolbar-title>
                        <strong> Allotted Subject / Group </strong>
                    </v-toolbar-title>
                </v-toolbar>
                 <v-col cols="12" md="12" sm="12" class="px-0">
                    <v-data-table
                        :items="choice_list"
                        :headers="headers_choice_list"
                        v-if="choice_list!=''"
                        class="elevation-1 mytable"
                        dense
                    >
                      <template v-slot:item.is_fees_paid="{ item }">
                    <span v-if="item.is_fees_paid">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                    </v-data-table>
                     <v-col cols="12" md="12" sm="12" class="px-0">
                        <center> <strong>Total Fees : {{ total_fees }}</strong> </center>
                     </v-col>
                </v-col>
            </v-row>
            <v-row justify="center" dense class="no-display" v-if="choice_list!=null">
                <v-btn
                    small
                    class="button"
                    v-if="pgs.includes('CCAVENUE')"
                    @click="initiateInvoiceCCAvenuePayment()"
                    :loading="loader"
                    :disabled="total_fees == 0"
                    >Pay Online [CCAVENUE]</v-btn
                >
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data() {
            return {
                ay_std_div_list: [],
                overlay: false,
                snackbar: false,
                search: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                sel_ay_data: null,
                orgid: null,
                uid: null,
                tenant: null,
                matrixPgList: null,
                choice_list: null,
                total_fees: null,
                studid: null,
                ay_id: null,
                hash_val: null,
                pgs: null,
                matrix_pg_list: null,
                stud_data: null,
                ay_name: null,
                receipts: [],
                total_fees:null,
                headers: [
                    { text: "Sr. No.", value: "srno", sortable: true, align: "center" },
                    { text: "Receipt No", value: "receipt_no", sortable: true, align: "center" },
                    { text: "Amount", value: "amount", sortable: true, align: "center" },
                    { text: "Date", value: "receipt_date", sortable: true, align: "center" },
                    { text: "Payment Mode", value: "payment_mode", sortable: true, align: "center" },
                    { text: "Remark", value: "remark", sortable: true, align: "center" },
                    { text: "Print Receipt", value: "print", sortable: true, align: "center" },
                ],
                headers_choice_list:[
                    { text: "Sr. No.", value: "srno", sortable: true, align: "center" },
                    { text: "Choice Number", value: "ch_no", sortable: true, align: "center" },
                    { text: "Subject Head", value: "sub_head", sortable: true, align: "center" },
                    { text: "Selection Type", value: "selectiontype", sortable: true, align: "center" },
                    { text: "Subject / Group", value: "course", sortable: true, align: "center" },
                    { text: "Fees", value: "fees", sortable: true, align: "center" },
                    { text: "Is Fees Paid ?", value: "is_fees_paid", sortable: true, align: "center" },
                    { text: "Fees Paid Amount", value: "fees_paid_amount", sortable: true, align: "center" },
                    { text: "Fees Payment Date", value: "fees_payment_date", sortable: true, align: "center" },
                ]
            };
        },
        watch: {},
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            async initiateInvoiceCCAvenuePayment() {
                let formData = new FormData();
                formData.append("orgid", this.orgid);
                formData.append("tenantid", this.tenant);
                formData.append("ay", this.ay_id);
                formData.append("uid", this.uid);
                formData.append("studid", this.studid);
                formData.append("fee_amount", this.total_fees);
                formData.append("json_pre_trans_data", this.matrix_pg_list);
                formData.append("hash_val", this.hash_val);
                formData.append("payment_type", "ELECTIVE FEES");
                formData.append("purpose", "ELECTIVE Fees");
                axios
                    .post("/paymentGatewayCCAvenue/initiateInvoiceCCAvenuePayment", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            var actionurl = res.data.redirection;
                            var access_code = res.data.merchant_key;
                            var encRequest = res.data.txnToken;
                            if (actionurl && encRequest && access_code) {
                                this.ccavenueRedirection(actionurl, encRequest, access_code);
                            }
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.fsmg);
                        }
                        this.loader = false;
                    })
                    .catch((error) => {
                        console.log(error);
                        this.loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    });
            },
            ccavenueRedirection(actionurl, token, access_code) {
                var form = document.createElement("form");
                var encRequest = document.createElement("input");
                var access_codes = document.createElement("input");

                form.method = "POST";
                form.id = "nomsemless";
                form.action = actionurl;

                encRequest.value = token;
                encRequest.name = "encRequest";
                encRequest.id = "encRequest";
                encRequest.type = "hidden";
                form.appendChild(encRequest);

                access_codes.value = access_code;
                access_codes.name = "access_code";
                access_codes.id = "access_code";
                access_codes.type = "hidden";
                form.appendChild(access_codes);

                document.body.appendChild(form);
                document.getElementById("nomsemless").style.display = "none";
                form.submit();
            },
            print(receipt_no, ay) {
                this.receipt_no = receipt_no;
                // this.dialog_print = true;
                this.$session.set("receipt_no", JSON.stringify(receipt_no));
                this.$session.set("ay", JSON.stringify(ay));
                this.$session.set("registration_no", JSON.stringify(this.registration_no.registration_number));
                if (this.org_id == "zeal") {
                    alert("Under development....");
                } else if (this.org_id == "wws") {
                    alert("Under development....");
                } else if (this.org_id == "uwws") {
                    alert("Under development....");
                } else if (this.org_id == "vvp") {
                    alert("Under development....");
                } else if (this.org_id == "sanjivani") {
                    alert("Under development....");
                } else if (this.org_id == "desschool") {
                    let routeData = this.$router.resolve({
                        name: "student-elective-fees-receipts-des",
                    });
                    window.open(routeData.href, "_blank");
                } else {
                    alert("Under development....");
                }
            },
            async getElectiveChoiceFeeDetails() {
                const data = {
                    ay: this.sel_ay_data,
                };
                try {
                    const res = await axios.post("/Admission/getElectiveChoiceFeeDetails", data);
                    if (res.data.flag == "YES") {
                        this.choice_list = res.data.choice_list;
                        this.matrixPgList = res.data.matrixPgList;
                        this.matrix_pg_list = JSON.stringify(this.matrixPgList);
                        this.total_fees = res.data.total_fees;
                        this.studid = res.data.studid;
                        this.ay_id = res.data.ay_id;
                        this.hash_val = res.data.hash_val;
                        this.stud_data = res.data.stud_data;
                        this.ay_name = res.data.ay_name;
                        this.receipts = res.data.receipts;
                        this.total_fees = res.data.total_fees
                        this.pgs = res.data.pgs
                        if (this.choice_list.length == 0) {
                            this.showSnackbar("#b71c1c", "No Data Found....");
                        }
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.smsg);
                    }
                } catch (error) {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                } finally {
                }
            },

            onload() {
                this.role = sessionStorage.getItem("para_role");
                const data = {
                    role: this.role,
                };
                axios
                    .post("/commonAPI/get_ay_std_div_wws_by_access", data)
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.orgid = localStorage.getItem("EPS-org-id");
            this.tenant = localStorage.getItem("EPS-tenant");
            this.uid = localStorage.getItem("EPS-uid");
        },
    };
</script>
<style scoped></style>
